export const previewKey = {
  homeFeed: 'homeFeed',
  messageDetail: 'messageDetail',
  webMessage: 'webMessage',
  sms: 'sms',
  email: 'email',
  line: 'line',
  whatsApp: 'whatsApp',
  linkedIn: 'linkedIn',
  instagram: 'instagram',
  facebook: 'facebook',
  twitter: 'twitter',
}
export const previewChannel = {
  [previewKey.homeFeed]: 'Home Feed',
  [previewKey.messageDetail]: 'Message Details',
  [previewKey.webMessage]: 'Web Message',
  [previewKey.sms]: 'SMS',
  [previewKey.email]: 'Email',
  [previewKey.line]: 'Line',
  [previewKey.whatsApp]: 'WhatsApp',
  [previewKey.linkedIn]: 'LinkedIn',
  [previewKey.instagram]: 'Instagram',
  [previewKey.facebook]: 'Facebook',
  [previewKey.twitter]: 'Twitter (X)',
}

export const optionPreview = [
  { id: previewKey.homeFeed, labelId: 'compose.preview.viewIn.homefeed' },
  {
    id: previewKey.messageDetail,
    labelId: 'notificationTimeline.card.metric.openRate.notification.title',
  },
]
